export const siteSettings = {
  name: "Coin Quote",
  link: "https://c-quote.live",
  email: "support@c-quote.live",
  appLink: "https://app.c-quote.live",
};
